var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00771 3.38892C7.00771 3.6826 6.76964 3.92067 6.47596 3.92067C6.18228 3.92067 5.94421 3.6826 5.94421 3.38892C5.94421 3.09525 6.18228 2.85718 6.47596 2.85718C6.76964 2.85718 7.00771 3.09525 7.00771 3.38892ZM7.00771 7.00004C7.00771 7.29371 6.76964 7.53178 6.47596 7.53178C6.18228 7.53178 5.94421 7.29371 5.94421 7.00004C5.94421 6.70636 6.18228 6.46829 6.47596 6.46829C6.76964 6.46829 7.00771 6.70636 7.00771 7.00004ZM7.00771 10.6111C7.00771 10.9048 6.76964 11.1429 6.47596 11.1429C6.18228 11.1429 5.94421 10.9048 5.94421 10.6111C5.94421 10.3175 6.18229 10.0794 6.47596 10.0794C6.76963 10.0794 7.00771 10.3175 7.00771 10.6111Z",
    fill: "#7D899D",
    stroke: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSmallIcon);
export default __webpack_public_path__ + "static/media/menu-small-icon.ac0987e2.svg";
export { ForwardRef as ReactComponent };